import { fromPromise } from 'xstate';

import type { AddressDetails, AddressWithoutIds } from '@order/features-locations';

import {
  addNewDeliveryAddressV2,
  getDefaultDeliveryLocation,
  getDeliveryLocationDetailsByAddress,
  getRadarDeliveryAddressPredictions,
} from '../../../services';
import {
  type DeliveryLocationWithoutNearbyStore,
  type Location,
  type PositionCoordinates,
} from '../../../types';

import type { Client } from 'urql';

// ─────────────────────────────────────────────────────────────────────────────

export const searchByDeliveryLocationAddressActor = fromPromise(
  async ({ input }: { input: SearchByDeliveryAddressActorInput }) =>
    getDeliveryLocationDetailsByAddress({
      client: input.client,
      address: input.address,
    }),
);

export const getDefaultDeliveryLocationActor = fromPromise(
  async ({ input }: { input: DefaultDeliveryLocationActorInput }) =>
    getDefaultDeliveryLocation({
      client: input.client,
      lastInteractedStoreAddressId: input.lastInteractedStoreAddressId,
    }),
);

export const searchDeliveryAddressesActor = fromPromise(
  async ({ input }: { input: SearchDeliveryAddressesActorInput }) => {
    const { client, deliverySearchString, currentPosition } = input;

    const near = currentPosition
      ? `${currentPosition.latitude},${currentPosition.longitude}`
      : undefined;

    return getRadarDeliveryAddressPredictions(client, deliverySearchString, near);
  },
);

export const addNewDeliveryAddressActor = fromPromise(
  async ({ input }: { input: AddNewDeliveryAddressActorInput }) => {
    return addNewDeliveryAddressV2(input.client, input.deliveryLocation);
  },
);

// ─── Types ───────────────────────────────────────────────────────────────────

export type SearchByDeliveryAddressActorInput = {
  client: Client;
  address: AddressDetails | AddressWithoutIds | undefined;
};

export type DefaultDeliveryLocationActorInput = {
  client: Client;
  lastInteractedStoreAddressId: string | undefined;
};

export type SearchDeliveryAddressesActorInput = {
  client: Client;
  deliverySearchString: string;
  currentPosition: PositionCoordinates | undefined;
};

export type AddNewDeliveryAddressActorInput = {
  client: Client;
  deliveryLocation: Location | DeliveryLocationWithoutNearbyStore | undefined;
};
